// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x1wLe__cta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6em 1.5em;
}

.wRIaC__label {
  font-weight: bold;
}

.Fpbji__buttons {
  display: inline-flex;
  align-items: center;
  gap: 1.5em;
}

.RHCpB__button {
  display: inline-flex;
  align-items: center;
}

.CwPB4__icon {
  display: block;
  height: 2.4em;
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/GetTheAppCTA.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb","sourcesContent":[".cta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.6em 1.5em;\n}\n\n.label {\n  font-weight: bold;\n}\n\n.buttons {\n  display: inline-flex;\n  align-items: center;\n  gap: 1.5em;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n}\n\n.icon {\n  display: block;\n  height: 2.4em;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export var cta = `x1wLe__cta`;
export var label = `wRIaC__label`;
export var buttons = `Fpbji__buttons`;
export var button = `RHCpB__button`;
export var icon = `CwPB4__icon`;
export default ___CSS_LOADER_EXPORT___;
